import mixpanel from 'mixpanel-browser';

import { returnPage } from './utils';

export const trackButtonClick = ({ type, route = '' }) => {
  if (route) {
    mixpanel.track('Button Clicked', { type: type, route: route });
  } else {
    mixpanel.track('Button Clicked', { type: type });
  }
};

export const trackLinkClick = ({ type }) => {
  mixpanel.track('Link Clicked', { type: type });
};

export const trackRoute = ({ route }) => {
  mixpanel.track('Page Changed', { route: route, page: returnPage({ route }) });
};

export const trackTakeTourAction = ({ takeTourType, action }) => {
  mixpanel.track('Take tour', { takeTourType, action });
};

// TODO
export const trackUserSubscriptionData = ({ user_name, email, subscriptions, organization }) => {
  // ! Remove for production push
  // Opt a user out of data collection
  // if (new RegExp("\\b" + "mikelegal" + "\\b").test(email)) {
  //   mixpanel.opt_out_tracking();
  // }
  mixpanel.identify(email);
  mixpanel.alias(email);
  mixpanel.register({
    'User Name': user_name,
    Email: email,
    Subscriptions: subscriptions,
    Organization: organization,
  });
  mixpanel.people.set({
    'User Name': user_name,
    Email: email,
    Subscriptions: subscriptions,
    Organization: organization,
  });
  mixpanel.track('Subscription Data');
};
